export default __webpack_public_path__ + "static/media/grun_logo.d933e446.png";